import { render } from "./DownwardsArrowSvg.vue?vue&type=template&id=336e9f62"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__